<template>
  <modal-default
    ref="commTextModal"
    subtitle="TEXT"
    :title="contact.full_name"
    is-double-column
    @close="closeModal"
  >
    <app-loading-section :loading="isCommsLoading" class="full-height">
      <div class="text_grid">
        <div class="text_grid--empty">
          <form-field-select
            v-model="logFilter"
            label="Show Messages"
          >
            <option :value="logFilterEnum.all">From all numbers</option>
            <option :value="logFilterEnum.selected">From selected to number only</option>
          </form-field-select>
        </div>

        <div class="text_grid--list">
          <div class="text_messages">
            <template v-if="messages.length !== 0">
              <comm-log-item
                v-for="message in messages"
                :key="message.id"
                :comm="message"
                show-user-avatar
              ></comm-log-item>

              <div class="flex flex-centered mt-100 mb-150">
                <button-link
                  v-if="showLoadMoreButton"
                  @click="loadMoreComms"
                  :loading="isLoadingMoreComms"
                >Load More Comms</button-link>

                <p v-else class="is-italic is-size-7 has-text-light">-- End of Log --</p>
              </div>
            </template>

            <div v-else class="messages--empty flex flex-vertical-center">
              <p>No message history</p>
            </div>
          </div>
        </div>

        <div class="text_grid--numbers">
          <form-field-select-contact-numbers
            label="Send Text To"
            v-model="selectedContactNumber"
            :contact="contact"
            :validation-errors="validationErrors.contact_number"
          ></form-field-select-contact-numbers>

          <form-field-select-integration-phone-number
            label="Send Text From"
            v-model="selectedIntegrationPhoneNumberId"
            :has-empty-option="false"
            :validation-errors="validationErrors.integrationPhoneNumber"
          ></form-field-select-integration-phone-number>

          <form-field-select-leads
            v-if="availableRecords"
            v-model="form.record_id"
            :records="availableRecords"
          >
          </form-field-select-leads>
        </div>

        <div class="text_grid--message">
          <form-field-editor
            v-if="recordIsSelected"
            ref="textField"
            key="withRecord"
            placeholder="write your text here..."
            v-model="form.body"
            type="textContactWithRecord"
            short-code-type="record"
            :validation-errors="validationErrors.body"
            is-short
          ></form-field-editor>

          <form-field-editor
            v-else
            ref="textField"
            key="withoutRecord"
            placeholder="write your text here..."
            v-model="form.body"
            type="textContactWithoutRecord"
            short-code-type="record"
            :validation-errors="validationErrors.body"
            is-short
          ></form-field-editor>
        </div>
      </div>
    </app-loading-section>

    <template v-slot:footer>
      <div class="flex flex-vertical-center flex-between" style="width: 100%">
        <div class="flex flex-between">
          <form-field-select
            class="mb-0 mr-50"
            v-model="sendNow"
          >
            <option :value="true">Send Now</option>
            <option :value="false">Send Later</option>
          </form-field-select>

          <form-field-datetime-picker
            class="mb-0"
            v-if="!sendNow"
            v-model="form.datetime"
            :min-date="minDate"
            position="is-top-right"
          ></form-field-datetime-picker>
        </div>

        <button-default
          v-if="sendNow"
          :loading="isLoading"
          :disabled="isLoading"
          @click="sendTextNow"
        >Send Text
        </button-default>

        <button-default
          v-if="!sendNow"
          :loading="isLoading"
          :disabled="isLoading"
          @click="sendTextLater"
        >Schedule Text
        </button-default>
      </div>
    </template>
  </modal-default>
</template>

<script>
import {ENUMS} from "../../services/enums";
import CommLogItem from "./components/CommLogItem";
import dates from "../../services/dates";
import api from "../../api";
import { MODELS } from "../../services/models";

export default {
  name: "CommTextModal",
  components: {CommLogItem},
  props: {
    contact: {
      type: Object,
      required: false
    },
    record: {
      type: Object,
      required: false
    },
    availableRecords: {
      type: Array,
    }
  },
  data() {
    return {
      comms: [], // Needs to be loaded after opened
      isCommsLoading: true,
      isLoading: false,
      minDate: dates.getNowJSDate(),
      sendNow: true,
      defaultForm: {
        record_id: null,
        body: "",
        integrationPhoneNumber: null,
        contact_number: null,
        datetime: dates.getTomorrowJSDate(9, 17),
      },
      form: null,
      lastText: null,
      selectedContactNumber: null,
      selectedIntegrationPhoneNumberId: null,
      validationErrors: {},
      logFilter: 1,
      logFilterEnum: {
        all: 1,
        selected: 2,
      },
      isLoadingMoreComms: false,
    };
  },
  computed: {
    recordIsSelected() {
      return !!(this.record || (this.form && this.form.record_id));
    },
    messages() {
      const messages = this.$store.getters["activeTextContactModal/communicationLogs"];

      // Filter out messages that don't belong to selected number if logFilter is set to selected.
      if (this.logFilter === this.logFilterEnum.selected) {
        return messages.filter(message => {
          const messageNumber = message.contact_number.replace(/\D/g, '');
          const selectedNumber = this.selectedContactNumber.value.replace(/\D/g, '');

          return messageNumber === selectedNumber
        })
      }

      return messages;
    },
    phoneNumbers() {
      return this.$store.getters.integrationPhoneNumbers;
    },
    campaign() {
      let campaignId = this.record ? this.record.campaign_id : null;
      return this.$store.getters.campaigns.find(campaign => campaign.id === campaignId);
    },
    showLoadMoreButton() {
      return this.$store.state.activeTextContactModal.showMoreCommsButton
    }
  },
  created() {
    this.form = this.$utils.clone(this.defaultForm);
    this.form.record_id = (this.record && !this.availableRecords) ? this.record.id : null;

    // this.setSelectedIntegrationPhoneNumberId();
  },
  mounted() {
    // used on Inbox page
    if (this.record) {
      if (!this.availableRecords) {
        this.form.record_id = this.record.id;
      }
    }
  },
  destroyed() {
    this.selectedContactNumber = null;
    this.selectedIntegrationPhoneNumberId = null;
    this.$store.dispatch("activeTextContactModal/tearDown");
  },
  methods: {
    open() {
      this.loadComms();
      this.$refs.commTextModal.open();
      this.$emit("open");
    },
    closeModal() {
      this.$store.dispatch("activeTextContactModal/tearDown");
    },
    loadComms() {
      this.isCommsLoading = true;
      const setup = this.$store.dispatch("activeTextContactModal/setup", this.contact.id);
      const initLastText = api.communicationLogs.lastText(this.contact.id);

      Promise.all([setup, initLastText])
        .then(([resSetup, resInitLastText]) => {
          this.lastText = resInitLastText.data;
          this.setSelectedIntegrationPhoneNumberId();
        })
        .finally(() => {
          this.isCommsLoading = false
        });
    },
    loadMoreComms() {
      this.isLoadingMoreComms = true

      this.$store.dispatch("activeTextContactModal/getCommLogs", this.contact.id)
        .finally(() => {
          this.isLoadingMoreComms = false
        });
    },
    setSelectedIntegrationPhoneNumberId() {
      // Get number if record or contact was created by a number
      let createdByNumber = undefined;
      if (this.contact && this.contact.createdBy.class_name === MODELS.IntegrationPhoneNumber.class_name) {
        createdByNumber = this.phoneNumbers.find(number => number.id === this.contact.createdBy.id);
      }
      else if (this.record && this.record.createdBy.class_name === MODELS.IntegrationPhoneNumber.class_name) {
        createdByNumber = this.phoneNumbers.find(number => number.id === this.record.createdBy.id);
      }

      // Get last text number if one exists
      let lastTextNumber = undefined;
      if (this.lastText.tracking_number) {
        lastTextNumber = this.phoneNumbers.find(number => number.number === this.lastText.tracking_number);
      }

      // If there is a previous comms then use the number the last comms went to
      if (lastTextNumber) {
        this.selectedIntegrationPhoneNumberId = lastTextNumber.id;
      }
      // If not, set it to the campaign number
      else if (this.campaign && this.campaign.integrationPhoneNumber) {
        this.selectedIntegrationPhoneNumberId = this.campaign.integrationPhoneNumber.id;
      }
      // If the lead/contact was created by na phone number
      else if (createdByNumber) {
        this.selectedIntegrationPhoneNumberId = createdByNumber.id;
      }
      // If not, then just use the first number in the list
      else if (this.phoneNumbers.length) {
        this.selectedIntegrationPhoneNumberId = this.phoneNumbers[0].id;
      }
    },
    isOutbound(message) {
      return message.communication_direction === ENUMS.CommunicationDirectionEnum.Outbound.value;
    },
    isInbound(message) {
      return message.communication_direction === ENUMS.CommunicationDirectionEnum.Inbound.value;
    },
    formatDate(message) {
      if (message.is_scheduled) {
        return dates.formatAsDateTime(message.scheduled_at);
      }

      return dates.formatAsDateTime(message.created_at);
    },
    clearTextPayload() {
      this.$refs.textField.clear();
    },
    sendTextNow() {
      this.isLoading = true;

      this.form.contact_number = this.selectedContactNumber.value;
      this.form.integrationPhoneNumber = this.phoneNumbers.find(num => num.id === this.selectedIntegrationPhoneNumberId);

      this.$api.integrationPhoneNumbers.textContact(this.contact.id, this.form, this.validationErrors)
        .then(() => {
          this.$buefy.toast.open({message: "Successfully Sent Text", type: "is-success"});
          this.clearTextPayload();
          this.isLoading = false;
        })
        .catch((error, validationErrors) => {
          if (error.response.status === 422) this.validationErrors = error.response.data.errors;
          this.isLoading = false;
        })
    },
    sendTextLater() {
      this.isLoading = true;

      this.form.contact_number = this.selectedContactNumber.value;
      this.form.integrationPhoneNumber = this.phoneNumbers.find(num => num.id === this.selectedIntegrationPhoneNumberId);

      this.$api.integrationPhoneNumbers.scheduledTextContact(this.contact.id, this.form, this.validationErrors)
        .then(() => {
          this.$buefy.toast.open({message: "Successfully Scheduled Text", type: "is-success"});
          this.clearTextPayload();
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status === 422) this.validationErrors = error.response.data.errors;
          this.isLoading = false;
        })
    },
    cancelScheduledText(messageId) {
      this.$utils.confirm(
        `Are you sure you want to <strong>cancel</strong> the scheduled text?`,
        "Cancel Scheduled Text"
      )
        .then(() => {
          this.$api.communicationLogs.cancelSchedule(messageId).then(res => {
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

::v-deep {

  .modal-card-body {
    height: calc(100vh - 80px - 41px - 51px);
  }

  .modal-inner {
    height: 100%;
    padding: 0;
  }
}

.full-height {
  height: 100%;
}

.text_grid {
  height: 100%;
  display: grid;
  grid-template-columns: 270px 1fr;
  grid-template-rows: 1fr 200px;
  gap: 0 0;
  grid-template-areas:
      "empty list"
      "numbers message";

  @include mobile {
    display: block;
  }
}

.text_grid--empty {
  grid-area: empty;
  padding: 14px;
}

.text_grid--list {
  grid-area: list;
  overflow-y: hidden;
  padding: 14px 14px 0;

  @include mobile {
    padding-top: 0;
  }
}

.text_grid--numbers {
  grid-area: numbers;
  padding: 0 14px;
}

.text_grid--message {
  grid-area: message;
  padding: 22px 14px 0;
}

.text_messages {
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  overflow-y: scroll;
  margin-bottom: 1rem;
  padding: 10px;
  border: 1px solid $border;

  .text_message {
    margin-bottom: 0.75rem;

    &.inbound {
      justify-content: flex-start;
    }

    &.outbound {
      justify-content: flex-end;
    }

    &--item {
      display: flex;
      width: 80%;

      &--message {
        padding: 6px 8px;
        background-color: $background;
        border-radius: 6px;
        font-size: 0.875rem;
      }

      &--details {
        display: flex;
        justify-content: space-between;
        margin-top: 2px;
        padding: 0 2px;
        font-size: 0.75rem;
        color: $text-light;

        &.outbound {
          text-align: right;

          &.scheduled {
            color: $orange;

            .unscheduled {
              cursor: pointer;
            }
          }
        }
      }

      &--avatar {
        margin-left: 6px;
      }
    }
  }

  &--empty {
    min-height: 200px;
    width: 100%;

    p {
      width: 100%;
      text-align: center;
      color: $text-light;
      font-style: italic;
    }
  }
}
</style>
